import React from "react";
import { Card } from "../modules/Harvests/Card";

export function NewHarvestPage(props) {
  return (
    <Card {...props} />
  );
}
